import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarTenagaKesehatanAdmin from "../../components/TopBarTenagaKesehatanAdmin";
import SemuaTenagaKesehatan from "../../components/SemuaTenagaKesehatan";
import "../../CSS/SemuaDataPasienAdmin.css";

function HalamanTenagaKesehatanAdmin() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarTenagaKesehatanAdmin />

        {/* Konten utama */}
        <div className="data-tenaga-page">
          <SemuaTenagaKesehatan/>
        </div>
      </div>
    </div>
  );
}

export default HalamanTenagaKesehatanAdmin;
